<template>
    <div class="form-group">
        <div class="font-weight-bold">
            {{ __('orders.documents.' + documentType) }}
        </div>
        <button v-if="documentExists"
                class="btn btn-light-primary"
                @click="downloadDocument"
        >
            <i class="fas fa-download"/>
            {{ __('actions.download_thing', {thing: __('orders.documents.' + documentType)}) }}
        </button>
        <button v-else class="btn btn-light-warning"
                @click="generateDocument"
                :disabled="waitingForAddress || addressDeleted"
        >
            <span v-if="loading" class="spinner spinner-white spinner-sm mr-7"/>
            <i v-else class="fas fa-file-pdf"/>
            {{ __('actions.generate_thing', {thing: __('orders.documents.' + documentType)}) }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        order: Object,
        documentType: String,
        waitingForAddress: Boolean,
        addressDeleted: Boolean,
    },

    data() {
        return {
            loading: false,
            documentExists: false
        }
    },

    mounted() {
        this.documentExists = this.getDocumentExists();
    },

    methods: {
        downloadDocument() {
            window.open(this.$route('orders.documents.download', [this.order.store_uuid, this.order.url_key, this.documentType]), '_blank');
        },

        generateDocument() {
            this.loading = true;
            axios.post(this.$route('orders.documents.generate', [this.order.store_uuid, this.order.url_key, this.documentType]))
                .then(response => {
                    this.loading = false;
                    this.documentExists = true;
                    toastr.success(response.data.message);
                })
                .catch((error) => {
                    this.loading = false;
                    let errorData = error.response.data;
                    toastr.error(errorData.message);
                })
        },

        getDocumentExists() {
            for (let document of this.order.documents) {
                if (document.type === this.documentType && document.file_exists) {
                    return true;
                }
            }

            return false;
        }
    }
}
</script>
